import API, { GraphQLResult } from "@aws-amplify/api";
import { mutation, query } from "gql-query-builder";
import { buildVariables } from "../libs/GraphQueryBuilder";
import {
    AdminResetUserPasswordAPIMutationVariables,
    AdminDisableUserAPIMutationVariables,
    CreateDefaultConfigurationMutationVariables,
    CreateDefaultConfigurationInput,
    UpdateDefaultConfigurationMutationVariables,
    UpdateDefaultConfigurationInput,
    ListDefaultConfigurationsQueryVariables,
    UpdateUserMutationVariables,
    UserType, ListPollsQueryVariables, DisableUserType, ListPollReportsQueryVariables
} from "../API";
import { getUserByUsername, updateUser } from "./UsersManager";

export function adminListAllPolls(
  fields: any[],
  options?: ListPollsQueryVariables
) {
  const _variables: ListPollsQueryVariables = {
    limit: options?.limit || 1000,
  };
  if (options?.filter) _variables.filter = options?.filter;
  if (options?.nextToken) _variables.nextToken = options?.nextToken;

  const variables = buildVariables<ListPollsQueryVariables>(_variables, [
    { key: "filter", name: "ModelPollFilterInput" },
  ]);
  const q = query({
    operation: "result: listPolls",
    fields,
    variables,
  });
  return API.graphql(q);
}

export function adminAssignStaff(userID: string) {
  const _variables: UpdateUserMutationVariables = {
    input: {
      id: userID,
      type: UserType.STAFF,
    },
  };
  const variables = buildVariables<UpdateUserMutationVariables>(_variables, [
    { key: "input", name: "UpdateUserInput!" },
  ]);
  const q = mutation({
    operation: "result: updateUser",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function adminCreateDefaultConfiguration(
  input: CreateDefaultConfigurationInput
) {
  const _variables: CreateDefaultConfigurationMutationVariables = {
    input,
  };
  const variables = buildVariables<CreateDefaultConfigurationMutationVariables>(
    _variables,
    [{ key: "input", name: "CreateDefaultConfigurationInput!" }]
  );
  const q = mutation({
    operation: "result: createDefaultConfiguration",
    fields: [],
    variables,
  });
  return API.graphql(q);
}

export function adminUpdateDefaultConfiguration(
  input: UpdateDefaultConfigurationInput
) {
  const _variables: UpdateDefaultConfigurationMutationVariables = {
    input,
  };
  const variables = buildVariables<UpdateDefaultConfigurationMutationVariables>(
    _variables,
    [
      { key: "input", name: "UpdateDefaultConfigurationInput!" },
      { key: "condition", name: "ModelDefaultConfigurationConditionInput" },
    ]
  );
  const q = mutation({
    operation: "result: updateDefaultConfiguration",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function adminUnassignStaff(userID: string) {
  const _variables: UpdateUserMutationVariables = {
    input: {
      id: userID,
      type: UserType.INDIVIDUAL,
    },
  };
  const variables = buildVariables<UpdateUserMutationVariables>(_variables, [
    { key: "input", name: "UpdateUserInput!" },
  ]);
  const q = mutation({
    operation: "result: updateUser",
    fields: ["id"],
    variables,
  });
  return API.graphql(q);
}

export function adminGetDefaultConfiguration() {
  const _variables: ListDefaultConfigurationsQueryVariables = {};
  const variables = buildVariables<ListDefaultConfigurationsQueryVariables>(
    _variables,
    []
  );
  const q = query({
    operation: "result: listDefaultConfigurations",
    fields: [
      {
        items: [
          "id",
          {
            theme: ["key", "region", "bucket"],
          },
          {
            background: ["key", "region", "bucket"],
          },
          {
            logo: ["key", "region", "bucket"],
          },
          {
            pollImage: ["key", "region", "bucket"],
          },
        ],
      },
    ],
    variables,
  });
  return API.graphql(q);
}

export function adminResetUserPassword(username) {
  const _variables: AdminResetUserPasswordAPIMutationVariables = {
    input: {
      username,
    },
  };
  const variables = buildVariables<AdminResetUserPasswordAPIMutationVariables>(
    _variables,
    [{ key: "input", name: "AdminResetUserPasswordAPIInput!" }]
  );
  const q = mutation({
    operation: "result: adminResetUserPasswordAPI",
    fields: [],
    variables,
  });
  return API.graphql(q);
}

export async function adminDisableUser(
  username: string,
  enable: boolean = false
) {
  let type = enable ? DisableUserType.ENABLE : DisableUserType.DISABLE;
  const _variables: AdminDisableUserAPIMutationVariables = {
    input: {
      username,
      type,
    },
  };
  const variables = buildVariables<AdminDisableUserAPIMutationVariables>(
    _variables,
    [{ key: "input", name: "AdminDisableUserAPIInput!" }]
  );
  const q = mutation({
    operation: "result: adminDisableUserAPI",
    fields: [],
    variables,
  });
  await API.graphql(q);
  const user: any = await getUserByUsername([{ items: ["id"] }], username);
  return updateUser(user.data.result.items[0].id, { disable: !enable });
}

export function adminEnableUser(username) {
    return adminDisableUser(username, true)
}

export function adminListPollReports(variables: ListPollReportsQueryVariables, fields: any[]) {
    const _variables = buildVariables<ListPollReportsQueryVariables>(variables, [])
    const q = query({
        operation: 'result: listPollReports',
        fields,
        variables: _variables
    })
    return API.graphql(q)
}
